const currentState = {
    meetingCRUD: {
        newMeeting: null,
        updatedMeeting: null,
        postponedMeetingId: null,
        cancelledMeetingId: null,
        startedMeetingId: null,
        completedMeetingId: null,
        deletedMeetingId: null,
        meetingNotification: {
            subject: null,
            message: null,
            sms: false,
            zoom: true,
        }
    },
    isInviteesDrawerOpen: false

};

const reducer = (state = currentState, action) => {
    switch (action.type) {
        case 'CREATE_MEETING':
            const clonedCreateMeetingCRUD = {
                ...state.meetingCRUD
            };

            clonedCreateMeetingCRUD.newMeeting = action.payload.token;

            return {
                ...state,
                meetingCRUD: clonedCreateMeetingCRUD
            };
        case 'ADD_MEETING_NOTIFICATION': {
            const clonedCreateMeetingCRUD = {
                ...state.meetingCRUD
            };

            clonedCreateMeetingCRUD.meetingNotification = {
                subject: action.payload.subject,
                message: action.payload.message,
                sms: action.payload.sms,
                zoom: action.payload.zoom
            };

            return {
                ...state,
                meetingCRUD: clonedCreateMeetingCRUD
            };

        }
        case 'REMOVE_MEETING_NOTIFICATION': {
            const clonedCreateMeetingCRUD = {
                ...state.meetingCRUD
            };

            clonedCreateMeetingCRUD.meetingNotification = {
                subject: null,
                message: null,
                sms: false,
                zoom: true
            };

            return {
                ...state,
                meetingCRUD: clonedCreateMeetingCRUD
            };

        }
        case 'UPDATE_MEETING':
            const clonedUpdateMeetingCRUD = {
                ...state.meetingCRUD
            };

            clonedUpdateMeetingCRUD.newMeeting = action.payload.token;

            return {
                ...state,
                meetingCRUD: clonedUpdateMeetingCRUD
            };
        case 'POSTPONE_MEETING':
            const clonedPostponeMeetingCRUD = {
                ...state.meetingCRUD
            };

            clonedPostponeMeetingCRUD.postponedMeetingId = action.payload.id;

            return {
                ...state,
                meetingCRUD: clonedPostponeMeetingCRUD
            };
        case 'CANCEL_MEETING':
            const clonedCancelMeetingCRUD = {
                ...state.meetingCRUD
            };

            clonedCancelMeetingCRUD.cancelledMeetingId = action.payload.id;

            return {
                ...state,
                meetingCRUD: clonedCancelMeetingCRUD
            };
        case 'START_MEETING':
            const clonedStartMeetingCRUD = {
                ...state.meetingCRUD
            };

            clonedStartMeetingCRUD.startedMeetingId = action.payload.id;

            return {
                ...state,
                meetingCRUD: clonedStartMeetingCRUD
            };
        case 'COMPLETE_MEETING':
            const clonedCompleteMeetingCRUD = {
                ...state.meetingCRUD
            };

            clonedCompleteMeetingCRUD.completedMeetingId = action.payload.id;

            return {
                ...state,
                meetingCRUD: clonedCompleteMeetingCRUD
            };
        case 'DELETE_MEETING':
            const clonedDeleteMeetingCRUD = {
                ...state.meetingCRUD
            };

            clonedDeleteMeetingCRUD.deletedMeetingId = action.payload.id;

            return {
                ...state,
                meetingCRUD: clonedDeleteMeetingCRUD
            };
        case 'OPEN_INVITEES_DRAWER':
            return {
                ...state,
                isInviteesDrawerOpen: true
            };
        case 'CLOSE_INVITEES_DRAWER':
            return {
                ...state,
                isInviteesDrawerOpen: false
            };
        default:
            return state;
    }
};

export default reducer;